import classes from './FormAccomplishments.module.css';
import { FaCheckCircle } from 'react-icons/fa'
import { BsFillXCircleFill } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';
import { Accomplishment } from '../../../contexts/interfaces';
import { convertDate } from '../../../utils/convertDate';
import { useCurrentDataContext } from '../../../contexts/CurrentDataContext';
import { useRequiredAccomplishmentsContext } from '../../../contexts/RequiredAccomplishmentsContext';
import {
    isRequiredAccomplishmentSatisfied,
    resolveAccomplishmentDate,
} from '../../../utils/accomplishmentDateRules';

interface Props {
    employeeAccomplishments: Accomplishment[] | undefined,
    fontSizeProps?: string | undefined,
    showOnlyRequired: boolean,
    checkFormData?: boolean,
    showOrigin?: boolean,
}

const FormAccomplishments = ({ employeeAccomplishments, fontSizeProps, showOnlyRequired, checkFormData, showOrigin }: Props) => {

    // Set translation
    const { t } = useTranslation();

    const { currentData } = useCurrentDataContext();

    const { requiredAccomplishments } = useRequiredAccomplishmentsContext();

    const origin = (fromAtt: boolean) => {

        // If accomplishment is verified by attachment, show it to user
        return fromAtt === true ? 'Liite, ' : ''
    };

    return (
        <>
            <div
                className={classes.formAccomplishmentsTitle}
                style={{ fontSize: fontSizeProps || '16px' }}
            >
                {t("formAccomplishments.title")}
            </div>
            <div
                className={classes.formAccomplishmentsColumn}
            >

                <div className={classes.formAccomplishmentsGrid}>
                    {
                        // Render required accomplishments
                        employeeAccomplishments && requiredAccomplishments && requiredAccomplishments.map((item, i) => {
                            const { date, fromAttachment: fromAtt } = resolveAccomplishmentDate(
                                item.type,
                                employeeAccomplishments,
                                {
                                    checkFormData,
                                    currentData,
                                }
                            );
                            const isValid = isRequiredAccomplishmentSatisfied(
                                item.type,
                                date
                            );

                            return (
                                <div
                                    key={i}
                                    className={classes.formAccomplishmentsItem}
                                >
                                    {
                                        isValid ?
                                            <FaCheckCircle className={classes.checkCircle} />
                                            : <BsFillXCircleFill className={classes.redCircle} />
                                    }
                                    <div
                                        className={date ? classes.formAccomplishmentsItemText : classes.formAccomplishmentsItemTextNoDate}
                                    >
                                        {item.title}
                                        {date && ` (${showOrigin ? origin(fromAtt) : ""}${convertDate(date) || ""})`}

                                    </div>
                                </div>
                            )
                        })
                    }

                    {
                        // Other accomplishments, ones that are not listed in required array
                        !showOnlyRequired &&
                        employeeAccomplishments &&
                        requiredAccomplishments &&
                        employeeAccomplishments.filter(acc =>
                            !requiredAccomplishments.some(reqA =>
                                reqA.type === acc.type)).map((item, i) => {
                                    return (
                                        <div
                                            key={i}
                                            className={classes.formAccomplishmentsItem}
                                        >
                                            <FaCheckCircle className={classes.checkCircle} />
                                            <div
                                                className={classes.formAccomplishmentsItemText}
                                            >
                                                {item.title} ({convertDate(item.date)})
                                            </div>
                                        </div>
                                    )
                                })
                    }
                </div>


            </div>
        </>
    )
};

export default FormAccomplishments;